module.exports = __webpack_public_path__ + "static/img/sence2.b244af0.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/index1/sence2.png
// module id = KByz
// module chunks = 7